// The signed-in person's profile (GET /profile) for everything inside the workspace: their role, their org, whether it's a
// demo, and which walkthroughs they've finished. MainPage.js loads it once; `refresh` reloads it after a change.
import { createContext, useContext } from 'react';

export const ProfileContext = createContext({ profile: null, refresh: () => {}, setToursDone: () => {} });

export const useProfile = () => useContext(ProfileContext);

export const isOwner = (profile) => ['owner', 'admin'].includes(profile?.role);
